import { Routes } from '@angular/router';
import { HubsPage } from './hubs.page';
import { v2On } from '../v2/ui-v2.guard';


export const hubsRoutes: Routes = [
    {
        path: 'hubs',
        component: HubsPage,
        children: [
            {
                path: '',
                redirectTo: 'manage',
                pathMatch: 'full'
            },
            {
                path: 'add',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/hubs/add-hub-v2.page').then( m => m.AddHubV2Page)
            },
            {
                path: 'add',
                loadComponent: () => import('./add-hub/add-hub.page').then( m => m.AddHubPage)
            },
            {
                path: 'add-kids',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/hubs/add-kids-hub-v2.page').then(m => m.AddKidsHubV2Page)
            },
            {
                path: 'add-kids',
                loadComponent: () => import('./add-kids-hub/add-kids-hub.page').then(m => m.AddKidsHubPage)
            },
            // {
            //     path: 'trips',
            //     component: TripsPage
            // },
            {
                path: 'manage',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/hubs/manage-hub-v2.page').then( m => m.ManageHubV2Page)
            },
            {
                path: 'manage',
                loadComponent: () => import('./manage-hub/manage-hub.page').then( m => m.ManageHubPage)
            },
            {
                path: 'details',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/hubs/hub-detail-v2.page').then( m => m.HubDetailV2Page)
            },
            {
                path: 'details',
                loadComponent: () => import('./hub-details/hub-details.page').then( m => m.HubDetailsPage)
            }
        ]
    },
    // {
    //     path: 'tabs/trip-detail',
    //     loadComponent: () => import('./trip-detail/trip-detail.page').then( m => m.TripDetailPage)
    // },
    
];